import LuruAPIRequest, { LuruAPIRequestOptions } from '../../LuruAPIRequest'
import { HTTPMethod } from '../../../app/types'

export const getLuruUserRoles = async (options: LuruAPIRequestOptions) => {
  var request = new LuruAPIRequest('/api/users/roles', HTTPMethod.GET, options)
  return request.make()
}
